import React, { useEffect, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Pagination from '@material-ui/lab/Pagination';
import Button from "components/CustomButtons/Button.js";

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";

import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";
import ModalAddBatchToCar from "components/ModalAddBatchToCar/ModalAddBatchToCar";
import TableBatch from "components/TableBatch/TableBatch";
import { Form } from "react-bootstrap";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    }
};


const useStyles = makeStyles(styles);

export default function BatchToCar() {

    const { storageId } = useAuth();
    const classes = useStyles();
    const index = { id: 1 };

    const [modalShow, setModalShow] = useState(false);
    const [batchToCar, setBatchToCar] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [batchs, setBatchs] = useState([{ batch: "NENHUM", weight: 0 }]);
    const [batchFilter, setBatchFilter] = useState("");
    const [id_car, setId_car] = useState("");
    const [id_deliveryman, setId_deliveryman] = useState("");
    const [cars, setCars] = useState([{ name_car: "NENHUM", deliverymanname: "" }]);
    const [deliverymans, setDeliverymans] = useState([{ deliverymanname: "NENHUM" }]);

    const [page, setPage] = useState(1);


    useEffect(() => {
        getAllBatchToCar();
        getAllCar();
        getAllBatchs();
        getAllDeliverymans();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getAllBatchToCar();
    }, [totalPages, page, id_car, id_deliveryman, batchFilter])


    const handleChange = (event, value) => {
        setPage(value);
    };

    async function getAllBatchToCar() {
        try {

            const response = await api.get('/batch_to_car?id=' + storageId + '&type=operator&page=' + page + '&id_car=' + id_car +'&id_deliveryman='+ id_deliveryman + '&batch=' + batchFilter);

            setTotalPages(response.headers['x-total-count'])

            setBatchToCar(response.data);

        } catch (error) {
            alert('erro: ' + error)
        }
    }

    async function getAllCar() {
        const response = await api.get('/car?id=' + storageId + '&type=operator&all=true')
        //setCars(response.data);
        for (let i = 0; i < response.data.length; i++) {
            setCars(cars => ([...cars, response.data[i]]));
        }
    }

    async function getAllDeliverymans() {
        const response = await api.get('/deliveryman?id=' + storageId + '&type=operator&all=true')
        //setCars(response.data);
        for (let i = 0; i < response.data.length; i++) {
            setDeliverymans(deliverymans => ([...deliverymans, response.data[i]]));
        }
    }

    async function getAllBatchs() {
        const response = await api.get('/batch_to_car/without/bound/' + storageId)
        for (let i = 0; i < response.data.length; i++) {
            setBatchs(batchs => ([...batchs, response.data[i]]));
        }
    }  

    return (

        <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para adicionar divisão de carga</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp+" "+ classes.maxwidht} onClick={() => setModalShow(true)}>
                            Adicionar divisão de carga
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="primary">
                                <Icon>directions_car</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para filtrar por carro</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Form.Control onChange={event => setId_car(event.target.value)} value={id_car} as="select" defaultValue="Choose...">
                            {cars.map(car => (
                                <option key={String(car.id)} value={car.id}>{car.name_car} - {car.deliverymanname}</option>
                            ))}
                        </Form.Control>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="info">
                                <Icon>data_usage</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para filtrar por lote</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Form.Control onChange={event => setBatchFilter(event.target.value)} value={batchFilter} as="select" defaultValue="Choose...">
                            {batchs.map(batch => (
                                <option key={String(batch.id)} value={batch.id}>{batch.batch}</option>
                            ))}
                        </Form.Control>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>data_usage</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para filtrar por lote</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Form.Control onChange={event => setId_deliveryman(event.target.value)} value={id_deliveryman} as="select" defaultValue="Choose...">
                            {deliverymans.map(deliveryman => (
                                <option key={String(deliveryman.id)} value={deliveryman.id}>{deliveryman.deliverymanname}</option>
                            ))}
                        </Form.Control>
                    </CardFooter>
                </Card>
            </GridItem>
            {batchToCar.map(batch => (
                <TableBatch key={String("Btc_" + batch.id)} batchToCar={batch} loadBatchToCar={getAllBatchToCar} />
            ))}
            <ModalAddBatchToCar key={String("Add_" + index.id)} props={index} show={modalShow}
                onHide={() => setModalShow(false)} getAllBatchToCar={getAllBatchToCar} />
            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer >
    );
}
